import Rows from "PFApp/components/table/rows";
import { TableColumn } from "PFApp/components/table/table_types";
import { ActionIcon } from "PFComponents/action_icon";
import { SkillsFrameworksResponse } from "PFCore/services/admin/skills_frameworks/fetch_skills_frameworks";
import { SkillsFramework } from "PFTypes";
import React, { Dispatch, SetStateAction, useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";

import { SkillsFrameworkData } from "../../skills_frameworks.types";
import { getFormattedSkillsFramework } from "../../utils";
import css from "./skills_frameworks_table.module.scss";
import { useSkillsFrameworksCellRenderer } from "./use_skills_frameworks_cell_renderer";

type SkillsFrameworksRowsProps = {
  setFrameworkToDelete: Dispatch<SetStateAction<SkillsFramework | null>>;
  skillsFrameworks: SkillsFrameworksResponse;
  columns: TableColumn[];
  isFetching?: boolean;
};

export const SkillsFrameworksRows = ({
  setFrameworkToDelete,
  skillsFrameworks,
  columns,
  isFetching
}: SkillsFrameworksRowsProps) => {
  const history = useHistory();
  const renderCell = useSkillsFrameworksCellRenderer();

  const skillsFrameworksEntries = useMemo<SkillsFrameworkData[]>(
    () => skillsFrameworks.entries.map((framework) => getFormattedSkillsFramework(framework)),
    [skillsFrameworks]
  );

  const renderActions = useCallback(
    (item: SkillsFramework) => (
      <span className={css.actions}>
        <ActionIcon
          name="edit"
          size="sm"
          onClick={() => history.push(`/admin/skills_frameworks/${item.id}/edit`)}
        />
        <ActionIcon name="remove" size="sm" color="paletteRed0" onClick={() => setFrameworkToDelete(item)} />
      </span>
    ),
    [history, setFrameworkToDelete]
  );

  return (
    <Rows
      className={css.skillsRow}
      items={skillsFrameworksEntries}
      columns={columns}
      isLoading={isFetching}
      renderCell={renderCell}
      renderActions={renderActions}
      classes={{ mediumColumn: css.mediumColumn }}
    />
  );
};
